export default __webpack_public_path__ + "static/media/plus_white_no_background.efe609e1.svg";